import { Component, AfterViewInit } from '@angular/core';
import { MainService } from '../../service/main.service';
import { MatTableDataSource } from '@angular/material/table';
import { ComplaintsService } from '../../service/complaints.service'
import { session } from 'src/environments/environment.session';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../shared/spinner.service';
import { ExcelService } from '../../service/file-export.service'
import { Router } from '@angular/router';
import { PdfGeneratorService } from '../../service/pdf-generator.service';
import { TranslationService } from '../../service/translation.service';

@Component({
  selector: 'app-complaint',
  templateUrl: './complaint.component.html',
  styleUrls: ['./complaint.component.css']
})
export class ComplaintComponent {
  // departmentMappings: any[]= [];
  // filteredDepartmentList: any[] = [];
  complaints: any[] = [];
  showComplaints: any[] = [];
  searchText: string = '';
  selectedZone: string | null = null;
  selectedDept: string | null = null;
  uniqueZones: string[] = [];
  uniqueDepartments: string[] = [];
  fromDate: string | null = null;
  toDate: string | null = null;
  myNumber = 50;
  displayedColumns: string[] = ['id', 'ticket_id', 'dept', 'zone', 'fullName', 'mobileNo', 'created', 'days_Open', 'status', 'action'];
  dataSource: any = [
  ];
  allComplaints: any[] = []
  constructor(private pdfService: PdfGeneratorService, private excel: ExcelService, private cs: ComplaintsService, public mainService: MainService, private tspinner: SpinnerService, private router: Router, public translation: TranslationService) {

  }

  currentPage = 1;
  pageSize = 10;
  totalPages = 0;
  page_list = [10, 20, 50, 100];
  totalRecords: any = 0;

  erpUser: any
  async ngOnInit() {

    this.erpUser = JSON.parse(atob(session.erpUser));
    // this.complaints.filterPredicate = (data:any, filter: any) => {
    //   const dataStr = Object.values(data).join('').toLowerCase();
    //   return dataStr.includes(filter);
    // };

    await this.getComplaints()

  }

  department = {};

  async getComplaints() {
    const obj = { b_acct_id: this.erpUser.b_acct_id,};

    this.tspinner.show('', '');

    try {
      const resp = await this.cs.getComplaints(JSON.stringify(obj));
      this.tspinner.hide();

      if (resp.error === false) {
        this.allComplaints = resp.data.map((complaint: any) => {
          try {
            const deptArray = JSON.parse(complaint.dept || '[]');
            complaint.departments = deptArray.map((item: any) => Object.values(item));
            complaint.deptName = complaint.departments.map((d: any) => Array.isArray(d) ? d.join(' ') : d.toString()).join(', ');
          } catch (err) {
            complaint.departments = [];
            complaint.deptName = complaint.dept || '';
          }
          return complaint;
        });

        // Extract unique zones and departments
        const zones = new Set<string>();
        const departments = new Set<string>();

        this.allComplaints.forEach(item => {
          if (item.zone) zones.add(item.zone);
          if (item.deptName) {
            // Split if multiple departments (though usually stored as one string in deptName now)
             departments.add(item.deptName);
          }
        });

        this.uniqueZones = Array.from(zones).sort();
        this.uniqueDepartments = Array.from(departments).sort();

        await this.applyFilters();
      } else {
        Swal.fire(this.translation.t('common', 'oopsTitle'), resp.data, 'error');
      }
    } catch (err) {
      this.tspinner.hide();
      console.error('Error fetching complaints:', err);
      Swal.fire(this.translation.t('common', 'oopsTitle'), this.translation.t('common', 'somethingWentWrong'), 'error');
    }
  }
  onDownloadPDF(obj: any) {
    const b_acct_id = this.erpUser.b_acct_id;
    this.pdfService.generateComplaintPDF(b_acct_id, obj.com_id);
  }

  ngAfterViewInit(): void {
    this.mainService.dataSource = this.allComplaints
  }


  applyFilters(): void {
   const searchValue = this.searchText.trim().toLowerCase();
  const zoneValue = this.selectedZone ? this.selectedZone.toLowerCase() : '';
  const deptValue = this.selectedDept ? this.selectedDept.toLowerCase() : '';

    let fromDateValue: Date | null = null;
    let toDateValue: Date | null = null;

    if (this.fromDate && !this.toDate) {
      fromDateValue = new Date(this.fromDate);
      fromDateValue.setHours(0, 0, 0, 0);
      toDateValue = new Date(this.fromDate);
      toDateValue.setHours(23, 59, 59, 999);
    } else if (!this.fromDate && this.toDate) {
      fromDateValue = new Date(this.toDate);
      fromDateValue.setHours(0, 0, 0, 0);
      toDateValue = new Date(this.toDate);
      toDateValue.setHours(23, 59, 59, 999);
    } else if (this.fromDate && this.toDate) {
      fromDateValue = new Date(this.fromDate);
      fromDateValue.setHours(0, 0, 0, 0);
      toDateValue = new Date(this.toDate);
      toDateValue.setHours(23, 59, 59, 999);
    }

    // Reset pagination to first page when filtering
    this.currentPage = 1;

    this.complaints = this.allComplaints.filter((item: any) => {
      const ticketId = item.ticket_id ? item.ticket_id.toString().toLowerCase() : '';
      const zone = item.zone ? item.zone.toLowerCase() : '';
      const fullName = item.full_name ? item.full_name.toLowerCase() : '';
      const mobileNo = item.mobile_no ? item.mobile_no.toString().toLowerCase() : '';
      const createDate = item.create_date ? item.create_date.toLowerCase() : '';
      const daysOpen = item.number_of_open_days ? item.number_of_open_days.toString().toLowerCase() : '';
      const status = item.status ? item.status.toLowerCase() : '';
      const deptStr = item.deptName ? item.deptName.toLowerCase() : '';

      // Check filters
      const matchesSearch = !searchValue || 
             ticketId.includes(searchValue) ||
             zone.includes(searchValue) ||
             fullName.includes(searchValue) ||
             mobileNo.includes(searchValue) ||
             createDate.includes(searchValue) ||
             daysOpen.includes(searchValue) ||
             status.includes(searchValue) ||
             deptStr.includes(searchValue);

      const matchesZone = !zoneValue || zone === zoneValue;
      const matchesDept = !deptValue || deptStr.includes(deptValue); // Use includes for departments as it might contain multiple

      let matchesDate = true;
      if (fromDateValue || toDateValue) {
        if (item.create_date) {
            let createDateVal: Date | null = null;
            const dateStr = item.create_date.split(' ')[0];
            const parts = dateStr.split(/[-/]/);
            if (parts.length === 3) {
              if (parts[0].length === 4) {
                 createDateVal = new Date(item.create_date);
              } else {
                 createDateVal = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
                 if (isNaN(createDateVal.getTime())) {
                    createDateVal = new Date(item.create_date);
                 }
              }
            } else {
              createDateVal = new Date(item.create_date);
            }
            
            if (createDateVal && !isNaN(createDateVal.getTime())) {
                if (fromDateValue && createDateVal < fromDateValue) matchesDate = false;
                if (toDateValue && createDateVal > toDateValue) matchesDate = false;
            }
        } else {
            matchesDate = false;
        }
      }

      return matchesSearch && matchesZone && matchesDept && matchesDate;
    });

    this.totalRecords = this.complaints.length;
    this.updatePages();
    this.updatePagedData();
  }

  clearFilters(): void {
    this.searchText = '';
    this.fromDate = null;
    this.toDate = null;
    this.selectedZone = null;
    this.selectedDept = null;
    this.applyFilters();
  }

  updatePages(): void {
    this.totalPages = Math.ceil(this.totalRecords / this.pageSize) || 1;
  }

  updatePagedData(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.showComplaints = this.complaints.slice(start, end);
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagedData();
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagedData();
    }
  }

  changePageSize(): void {
    this.currentPage = 1;
    this.updatePages();
    this.updatePagedData();
  }

  onSearchChange(): void {
    this.applyFilters();
  }
  route(element: any) {
    this.router.navigate(['/sdp/complaints/preview'], {
      state: { data: element }
    });
  }


  exportToExcel() {
    let dataForExport = this.complaints.map((row: any) => {
      let departments = '';
      try {
        if (row.departments && Array.isArray(row.departments)) {
          departments = row.departments.map((d: any) => Array.isArray(d) ? d.join(' ') : d.toString()).join(', ');
        } else if (row.dept) {
          const deptArray = JSON.parse(row.dept);
          departments = deptArray.map((item: any) => Object.values(item)).join(', ');
        }
      } catch (e) {
        departments = row.dept || '';
      }

      return {
        [this.translation.t('operatorComplaint', 'ticketId')]: row.ticket_id,
        [this.translation.t('operatorComplaint', 'department')]: departments,
        [this.translation.t('operatorComplaint', 'zone')]: row.zone,
        [this.translation.t('operatorComplaint', 'fullName')]: row.full_name,
        [this.translation.t('operatorComplaint', 'mobileNo')]: row.mobile_no,
        [this.translation.t('operatorComplaint', 'createDate')]: row.create_date,
        [this.translation.t('operatorComplaint', 'daysOpen')]: row.number_of_open_days,
        [this.translation.t('operatorComplaint', 'status')]: row.status
      };
    });
    this.excel.exportAsExcelFile(dataForExport, 'Complaints');
  }

  activeRow: any = null;

  togglePrintOption(rowObj: any) {
    if (this.activeRow === rowObj) {
      this.activeRow = null;  // close if already open on same row
    } else {
      this.activeRow = rowObj;  // open on clicked row
    }
  }

  exportToPDF() {
    let headings = [
      this.translation.t('export', 'srNo'),
      this.translation.t('operatorComplaint', 'ticketId'),
      this.translation.t('operatorComplaint', 'department'),
      this.translation.t('operatorComplaint', 'zone'),
      this.translation.t('operatorComplaint', 'fullName'),
      this.translation.t('operatorComplaint', 'mobileNo'),
      this.translation.t('operatorComplaint', 'createDate')
    ];
    
    // The service expects the raw data objects and handles extraction of fields internally
    // We pass the filtered list (this.complaints) directly
    this.pdfService.generateTablePDF(this.complaints, 'Complaints_List', headings);
  }

  closePrintOption() {
    this.activeRow = null;
  }


}
